import React,{useEffect} from 'react';
import SaleLoader from 'app/Components/Shared/SaleLoader/SaleLoader.js';
import {getTextOrDefault, getImageUrlOrDefault} from 'app/Components/Block/BusinessDashboardBlock/utils/functions';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import {connect} from 'react-redux';

const CheckRegistrationStatusLoader = ({
  contentData,
  isLoading,
  hideAppLoader
}) => {
  const {cellcomTvLogo, mainImage, popupMainTitle} = contentData || {};
  const cellcomTvLogoUrl = getImageUrlOrDefault(cellcomTvLogo);
  const mainImageUrl = getImageUrlOrDefault(mainImage);
  const popupMainTitleText = getTextOrDefault(popupMainTitle);

  useEffect(() => {
    if(isLoading){
      hideAppLoader();
    }
  }, []);

  return (
    <div className="check-registration-status-loader-container">
        {cellcomTvLogoUrl && <img src={cellcomTvLogoUrl} className="tv-plus-logo" />}
        <div className='image-and-title-container'>
          {mainImageUrl && <img src={mainImageUrl} className="main-image"/>}
          {popupMainTitleText && <span className='main-title' dangerouslySetInnerHTML={{__html: popupMainTitleText}} />}
        </div>
        <SaleLoader />
    </div>
  );
}

const mapStateToProps = (state) => ({
  isLoading: state.loader?.isLoading,
});
export default connect(mapStateToProps, {showAppLoader, hideAppLoader})(CheckRegistrationStatusLoader);
